var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CamparatorNav',{attrs:{"isMobile":_vm.isMobile,"type":this.$route.params.type}}),_c('ComparatorBody',{attrs:{"isMobile":_vm.isMobile,"type":this.$route.params.type,"cardData":_vm.returData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }